import { render } from "./ViewUsersModal.vue?vue&type=template&id=0508b25c&ts=true"
import script from "./ViewUsersModal.vue?vue&type=script&lang=ts"
export * from "./ViewUsersModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__